import { ArrowRight, BookOpen, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "../data/content";
import { Reveal } from "./Reveal";

export const CTASection = () => {
  return (
    <section data-testid="cta-section" className="py-10 sm:py-14 lg:py-18 bg-brand-charcoal grain overflow-x-hidden relative">
      <div
        aria-hidden="true"
        className="absolute inset-x-0 -top-32 h-[400px] bg-gradient-to-b from-brand-teal/15 to-transparent blur-3xl pointer-events-none"
      />
      <div className="relative max-w-5xl mx-auto px-5 sm:px-6 lg:px-10 text-center">
        <Reveal>
          <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-brand-gold">
            Let&rsquo;s Feed the Room
          </p>
        </Reveal>
        <Reveal delay={1}>
          <h2 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white leading-[1.02]">
            Planning an Event?
            <br />
            <span className="text-brand-gold">Let&rsquo;s Feed the Room.</span>
          </h2>
        </Reveal>
        <Reveal delay={2}>
          <p className="mt-6 text-[16px] sm:text-[17px] text-white/75 leading-relaxed max-w-2xl mx-auto">
            From school events to office lunches and community programs, Fresh Fast Foods
            LLC makes catering simple, fresh, and reliable.
          </p>
        </Reveal>

        <Reveal delay={3}>
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-3xl mx-auto">
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="cta-contact-us-btn"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-white text-brand-charcoal px-4 py-3.5 text-[11.5px] sm:text-[12px] font-bold uppercase tracking-[0.1em] hover:bg-brand-gold transition-colors whitespace-nowrap"
            >
              <Mail className="h-3.5 w-3.5" />
              Contact Us
            </a>
            <a
              href={`tel:${BRAND.phoneTel}`}
              data-testid="cta-call-btn"
              className="group inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/30 text-white px-4 py-3.5 text-[11.5px] sm:text-[12px] font-bold uppercase tracking-[0.1em] hover:bg-white hover:text-brand-charcoal transition-colors whitespace-nowrap"
            >
              <Phone className="h-3.5 w-3.5" />
              Call
            </a>
            <Link
              to="/menu"
              data-testid="cta-view-menu-btn"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand-charcoal border-2 border-brand-gold text-brand-gold px-4 py-3.5 text-[11.5px] sm:text-[12px] font-bold uppercase tracking-[0.1em] hover:bg-brand-gold hover:text-brand-charcoal transition-colors whitespace-nowrap"
            >
              <BookOpen className="h-3.5 w-3.5" />
              View Menu
            </Link>
            <Link
              to="/quote"
              data-testid="cta-request-quote-btn"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand-teal text-white px-4 py-3.5 text-[11.5px] sm:text-[12px] font-bold uppercase tracking-[0.1em] hover:bg-brand-teal-dark transition-all hover:scale-[1.02] shadow-[0_18px_40px_-18px_rgba(0,166,178,0.7)] whitespace-nowrap"
            >
              Request Quote
              <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTASection;
